var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.095 6.95996H2.515C1.685 6.95996 1.015 7.63496 1.015 8.45996V13.42C1.015 14.245 1.685 14.92 2.515 14.92H4.095C4.92 14.92 5.595 14.245 5.595 13.42V8.45996C5.595 7.63496 4.92 6.95996 4.095 6.95996Z",
    fill: "#FF6D00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.485 6.95996H8.405C7.575 6.95996 6.905 7.63496 6.905 8.45996V13.42C6.905 14.245 7.575 14.92 8.405 14.92H13.485C14.315 14.92 14.985 14.245 14.985 13.42V8.45996C14.985 7.63496 14.315 6.95996 13.485 6.95996Z",
    fill: "#282828"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.485 1.01501H2.515C1.68657 1.01501 1.015 1.68659 1.015 2.51501V4.46001C1.015 5.28844 1.68657 5.96001 2.515 5.96001H7.485C8.31343 5.96001 8.985 5.28844 8.985 4.46001V2.51501C8.985 1.68659 8.31343 1.01501 7.485 1.01501Z",
    fill: "#282828"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.485 1.01501H11.785C10.9566 1.01501 10.285 1.68659 10.285 2.51501V4.46001C10.285 5.28844 10.9566 5.96001 11.785 5.96001H13.485C14.3134 5.96001 14.985 5.28844 14.985 4.46001V2.51501C14.985 1.68659 14.3134 1.01501 13.485 1.01501Z",
    fill: "#FF6D00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.cfd4a3b689b7cdc14d7569fdf4a30b75.svg";
export { ForwardRef as ReactComponent };